import { TitanButton } from "@lib/titan2/dist/game/control/TitanButton";
export class BonusHelp extends TitanButton {
    constructor(landscapeProperties, portraitProperties, clickHandler) {
        super(landscapeProperties, portraitProperties);
        this.onClick(clickHandler, null);
    }
}
//# sourceMappingURL=BonusHelp.js.map